import { render } from "./FeedBack.vue?vue&type=template&id=3134b81a&scoped=true&ts=true"
import script from "./FeedBack.vue?vue&type=script&lang=ts"
export * from "./FeedBack.vue?vue&type=script&lang=ts"

import "./FeedBack.vue?vue&type=style&index=0&id=3134b81a&lang=scss&scoped=true"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3134b81a"]])

export default __exports__